import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../security/authentication.service';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { SignupService } from './signup.service';
import { AlertService } from '../shared/alert/alert.service';
import { User } from '../entity/user';
import { ThirdParty } from '../entity/third-party';


@Component({
  selector: 'signup',
  templateUrl: './signup.component.html'
})
export class SignupComponent {
  user_type: string;
  siret: string;
  step: number;
  thirdParty: ThirdParty;
  isCheckingSiret: boolean;
  isSiretValid: boolean;
  isPasswordValid: boolean;
  isSiretError: boolean;
  siretErrorMsg: string;
  emailErrorMsg: string;
  passwordErrorMsg: string;
  email: string;
  password: string;
  confirm_password: string;

  constructor(private router: Router, private signupService: SignupService, private alertService: AlertService, private spinnerService: SpinnerService) { 
    this.user_type = "entreprise";
    this.step = 1;
    this.siret = "";
    this.thirdParty = null;
    this.isCheckingSiret = false;
    this.isSiretValid = false;
    this.isPasswordValid = false;
    this.isSiretError = false;
    this.siretErrorMsg = "";
    this.emailErrorMsg = "";
    this.passwordErrorMsg = "";
    this.email = "";
    this.password = "";
    this.confirm_password = "";
  }

  ngOnInit() {
    
  }

  checkSiret(): void {    
    this.isSiretValid = null;
    this.siretErrorMsg = "";
    this.siret = this.siret.trim();
    if(this.siret.length >= 17){
      this.isCheckingSiret = true;
      this.signupService.checkSiret(this.siret).then(function(thirdParty: ThirdParty){
        this.thirdParty = thirdParty
        this.isCheckingSiret = false;
        if(thirdParty.id==null){
          this.siretErrorMsg = "Ce numéro de SIRET n'est pas reconnu en tant que client Mylab. Veuillez réessayer.";
        } else {
          if(thirdParty.siteUser){
            this.siretErrorMsg = "Il y existe déjà un compte utilisateur associé à ce numéro de SIRET."
          } else {
            this.email = this.getEmail(thirdParty);
          }
        } 

        if(!this.siretErrorMsg){
          this.isSiretValid = true;
          this.isSiretError = false;
        } else {
          this.isSiretValid = false;
          this.isSiretError = true;
        }
      }.bind(this));
    } else {
      this.isSiretValid = false;
    }

  }

  public getEmail(thirdParty) {
    let email = thirdParty.getDefaultContact().mail;
    let email_array = email.split(";");
    return email_array[0];
  }

  next(event): void {
    event.preventDefault();
    this.step++;
  }

  back(event): void {
    event.preventDefault();
    this.step--;
  }

  public displayPrev(): boolean
  {
    let display = false;
    switch (this.step) {
      case 2 :
        display = true;
        break;
      default:
        display = false;
    }
    return display;    
  }

  public displayNext(): boolean
  {
    let display = false;
    switch (this.step) {
      case 1 :
        display = true;
        break;
      default:
        display = false;
    }
    return display;    
  }

  public stepIsValid(): boolean {
    let valid = false;
    switch (this.step) {
      case 1 :
        valid = this.isSiretValid;
        break;
      case 2 :
        valid = this.emailErrorMsg.length==0 && this.isPasswordValid;
        break;
      default:
        valid = false;
    }
    return valid;
  }

  private checkMailAvailability = function() {
    var params = {
        email: this.mail
    };
    this.signupService.checkEmail(this.email).then(
      function(response){
        if(!response){
          this.emailErrorMsg = "Cette adresse email est déjà utilisée";
        }
      }.bind(this)
    );
  }

  public checkMail = function(showError){
    this.emailErrorMsg = "";
    let regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let valid = regex.test(this.email);
    if (valid) {
      this.checkMailAvailability();
    } else {
      this.emailErrorMsg = "L'adresse email n'est pas valide";
    }
  }

  public signupUser(event): void {
    event.preventDefault();
    let thirdPartyId = this.thirdParty.id;
    if(this.checkPassword(true)){
      this.spinnerService.start("Creation de compte");
      this.signupService.signup(thirdPartyId, this.email, this.password).then(
          function(response){
            if(response.success){
              this.router.navigate(['login']);
              this.alertService.success(response.message);
            }else{
              this.alertService.error(response.errorMessage);
            }
            this.spinnerService.stop();
          }.bind(this)
        );
    }
  }

  private checkPasswordComplexity() {
    return this.password.length>5;
  }

  public checkPassword(showError){
    let valid = true;
    this.passwordErrorMsg = "";
    if(this.checkPasswordComplexity()){
      if (this.password != this.confirm_password) {
        valid = false;
        if(showError && this.confirm_password.length > 0) {
          this.passwordErrorMsg = "Les mots de passes ne sont pas identiques";
        }
      }
    } else {
      valid = false;
      if(this.password.length > 0 && showError){
        this.passwordErrorMsg = "Le mots de passe n'est pas assez sécurisé";
      }
    }
    this.isPasswordValid = valid;
    return valid;
  }
}



// WEBPACK FOOTER //
// ./src/app/signup/signup.component.ts